import { render, staticRenderFns } from "./AssessmentsHistory.vue?vue&type=template&id=2e61bf1d&scoped=true&"
import script from "./AssessmentsHistory.vue?vue&type=script&lang=js&"
export * from "./AssessmentsHistory.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentsHistory.vue?vue&type=style&index=0&id=2e61bf1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e61bf1d",
  null
  
)

export default component.exports